import classNames from 'classnames'

import { Button, IButtonProps } from 'core-components/library/button'

import styles from './Progress.module.scss'

export interface IProgressProps {
  /**
   * Progress minimum value.
   */
  minValue: number
  /**
   * Progress maximum value.
   */
  maxValue: number
  /**
   * The size of the value change step.
   */
  step: number
  /**
   * Current value
   */
  value: number
  /**
   * Callback on value changed
   */
  onChange?: (newValue: number) => void
  /**
   * Classes for inner elements
   */
  classes?: {
    root?: string
    button?: string
    progressBar?: string
    filler?: string
  }
  /**
   * Color of action buttons.
   */
  colorButton?: IButtonProps['color']
  /**
   * DEPRECATED. Use classes.root option
   */
  className?: string // TODO: delete
}

export const Progress = ({
  className,
  classes,
  minValue,
  maxValue,
  step,
  value,
  onChange,
  colorButton,
}: IProgressProps) => {
  const getPercentage = (now: number, min: number, max: number) => {
    const percentage = ((now - min) / (max - min)) * 100
    return Math.round(percentage * 1000) / 1000
  }

  return (
    <div className={classNames(styles.root, classes?.root, className)} data-testid={'progressRoot'}>
      {onChange && (
        <Button
          color={colorButton}
          className={classes?.button}
          variant={'text'}
          iconButton={'kbase kbase-minus'}
          onClick={() => value > minValue && onChange && onChange(value - step)}
          __testId={'progressButton-minus'}
        />
      )}
      <div
        data-testid={'progressMain'}
        role="progressbar"
        className={classNames(styles.bar, classes?.progressBar)}
        aria-valuenow={value}
        aria-valuemin={minValue}
        aria-valuemax={maxValue}
        onClick={(e) => {
          const range = (maxValue - minValue) / e.currentTarget.offsetWidth
          const value = minValue + range * e.nativeEvent.offsetX
          onChange && onChange(Math.trunc((value - minValue) / step) * step + minValue)
        }}
      >
        <div
          className={classNames(styles.filler, classes?.filler)}
          style={{ width: `${getPercentage(value, minValue, maxValue)}%` }}
          data-testid={'progressFiller'}
        />
      </div>
      {onChange && (
        <Button
          color={colorButton}
          className={classes?.button}
          variant={'text'}
          iconButton={'kbase kbase-add'}
          onClick={() => value < maxValue && onChange && onChange(value + step)}
          __testId={'progressButton-plus'}
        />
      )}
    </div>
  )
}
